export const CHAT_AREA_INPUT_MAX_WIDTH_PX = 1000
export const CHAT_AREA_MESSAGES_MAX_WIDTH_PX = 1400
export const CONVERSATIONS_PAGE_SIZE = 10
export const CONVERSATION_LIST_NOW_INTERVAL_MS = 60_000
export const CONVERSATION_TITLE_MAX_CHARS = 100
export const CONVERSATION_TITLE_MIN_CHARS = 3
export const DESKTOP_PADDINGX_PX = 20
export const FEEDBACK_MESSAGE_MAX_INPUT_CHARS = 1000
export const FEEDBACK_MESSAGE_MIN_INPUT_CHARS = 3
export const FETCH_NEXT_PAGE_DELAY_MS = 1_000
export const FETCH_NEXT_PAGE_SCROLL_TOP_THRESHOLD_PX = 24
export const FIRST_PAGE_INDEX = 0
export const HEADER_HEIGHT_PX = 80
export const MAX_WIDTH_PX = 1200
export const MESSAGES_PAGE_SIZE = 5
export const MOBILE_BREAKPOINT_PX = 680
export const MOBILE_BREAKPOINT_WITH_PADDING_PX = MOBILE_BREAKPOINT_PX + 2 * DESKTOP_PADDINGX_PX
export const PENDING_ASSISTANT_MESSAGE_ID = -2
export const PENDING_CONVERSATION_ID = 'PENDING'
export const PENDING_MESSAGE_ID_INCREMENT = 0.01
export const PENDING_STATE_CHECKER_BACKGROUND_POLLING_MS = 30_000
export const PENDING_STATE_CHECKER_FOREGROUND_POLLING_MS = 10_000
export const PENDING_TIMEOUT_DELAYS_MS = [2_000, 3_000, 4_000, 5_000, 8_000]
export const PENDING_USER_MESSAGE_ID = -1
export const PROMPT_MAX_INPUT_CHARS = 1000
export const PROMPT_MAX_TEXTAREA_ROWS = 3
export const PROMPT_MIN_INPUT_CHARS = 1
export const PROMPT_TEXTAREA_LINE_HEIGHT_FALLBACK_PX = 24
export const REQUEST_CREDITS_URL: Record<string, string> = {
  en: 'https://discover.rateboard.io/en/rateboard-next-credit-request',
  de: 'https://discover.rateboard.io/rateboard-next-guthaben-anfrage',
  it: 'https://discover.rateboard.io/it/rateboard-next-richiesta-di-credito',
}
export const SIDEBAR_WIDTH_PX = 250
